import { render, staticRenderFns } from "./mystep.vue?vue&type=template&id=98dcd8e4"
import script from "./mystep.vue?vue&type=script&lang=js"
export * from "./mystep.vue?vue&type=script&lang=js"
import style0 from "./mystep.vue?vue&type=style&index=0&id=98dcd8e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports